import React, { Component } from 'react';
import InputItem from './CustomerInput';
import PropTypes from 'prop-types';

class InputNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.format(this.props.value),
      defaultValue: this.format(this.props.defaultValue)
    };
    let min = this.props.min;
    let max = this.props.max;
    if (typeof min === 'number' && typeof max === 'number') {
      if (max < min) {
        let temp = max;
        max = min;
        min = temp;
      }
    }
    this.min = min;
    this.max = max;
  }
  componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      this.setState({
        value: this.format(nextProps.value)
      });
    }
  }
  //校验数字
  numValidate = (val) => {
    val = val + '';
    const precision = this.props.precision || 0;
    const sign = this.props.sign || false;
    let reg = /^(([1-9]\d*)|0)$/;
    if (precision && sign) {
      reg = /^-?((([1-9]\d*)|0)\.\d*)?$/;
    } else if (precision) {
      reg = /^(([1-9]\d*)|0)(\.\d*)?$/;
    } else if (sign) {
      reg = /^-?(([1-9]\d*)|0)$/;
    }
    if (val === '') {
      return true;
    }
    if (!reg.test(val)) {
      return false;
    }
    return true;
  };
  rangeFormat = (val) => {
    let numVal = parseFloat(val);
    if (typeof this.min === 'number' && numVal < this.min) {
      return this.props.min;
    }
    if (typeof this.max === 'number' && numVal > this.max) {
      return this.props.max;
    }
    return val + '';
  };
  precisionFormat = (val) => {
    const precision = this.props.precision;
    val = val + '';
    if (precision && val.indexOf('.') !== -1) {
      let vals = val.split('.');
      let head = vals[0];
      let tail = vals[1];
      if (tail.length > precision) {
        tail = tail.substring(0, precision);
      }
      return head + '.' + tail;
    } else {
      return val;
    }
  };
  format = (val) => {
    if (typeof val === 'undefined' || val === '') {
      return '';
    }
    if (/^0[0-9]$/.test(val)) {
      return val.substring(1, val.length);
    }
    if (!this.numValidate(val)) {
      return this.state.value;
    }
    val = this.rangeFormat(val);
    val = this.precisionFormat(val);
    return val;
  };
  onChange = (val) => {
    val = this.format(val);

    this.setState(
      {
        value: val
      },
      () => {
        this.props.onChange && this.props.onChange(val);
      }
    );
  };
  onBlur = (val) => {
    if (val === '.') {
      val = '';
    } else if (!val && val !== 0) {
      val = '';
    } else {
      val = parseFloat(val) + '';
    }
    this.setState(
      {
        value: val + ''
      },
      () => {
        this.props.onBlur && this.props.onBlur(val);
      }
    );
  };
  render() {
    return (
      <InputItem
        {...this.props}
        className={' text-right ' + this.props.className}
        defaultValue={this.state.value}
        onBlur={this.onBlur}
        onChange={this.onChange}
        onFocus={() => {
          this.max = this.props.max;
          this.min = this.props.min;
          if (this.props.onFocus) {
            this.props.onFocus();
          }
        }}
        //  这里去掉 digit ios 表现不一致
        // type="digit"
        value={this.state.value}
      />
    );
  }
}

InputNumber.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // 输入框绑定值
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // 输入框默认值（不存在绑定值时生效）
  min: PropTypes.number, //最小值
  max: PropTypes.number, //最大值
  precision: PropTypes.number, //精度（小数位数）
  sign: PropTypes.bool //是否可以带符号（-/+）
};

export default InputNumber;
